<p-dialog
    appDialogoPadrao="pi pi-search"
    descricao="Busque a pessoa no cadastro."
    [style]="{ minWidth: '30rem', maxWidth: '85vw' }"
    [(visible)]="showDialog"
    (onHide)="hideDialog()"
    [breakpoints]="{ '1280px': '85vw', '1100px': '75vw', '500px': '90vw' }"
    header="Pesquisa de Pessoa"
    styleClass="dialog-fullscreen-mobile"
    [maximizable]="true"
    (onResizeEnd)="onDialogMaximize($event)"
    (onShow)="onShow()"
>
    <ng-template pTemplate="content">
        <div class="p-fluid formgrid grid" [formGroup]="formPesquisa">
            <div class="grid grid-cols-[repeat(auto-fit,minmax(100px,1fr))] gap-4">
                <div class="field [grid-column:1/-1] md:col-span-2">
                    <label for="tipo" class="font-semibold block mb-2">Tipo</label>
                    <p-select id="tipo" [options]="getTiposPessoaPesquisa()" formControlName="tipo" optionLabel="name" optionValue="code" class="h-[30px] w-full" [showClear]="!hasTiposPessoaRestritos()" placeholder="Todos"></p-select>
                </div>

                <div class="field [grid-column:1/-1] md:col-span-2">
                    <label for="uf" class="font-semibold block mb-2">UF</label>
                    <app-estado-select [uf]="formPesquisa.controls.uf.value" [ufsPermitidas]="ufsPermitidas" (ufChange)="changeuf($event)"></app-estado-select>
                </div>

                <div class="field [grid-column:1/-1] md:col-span-4">
                    <label for="nome" class="font-semibold block mb-2">Nome / Razão Social</label>
                    <input pInputText id="nome" class="w-full" formControlName="nome" placeholder="Nome / Razão Social" />
                </div>
            </div>

            @if (isPrestadorSelecionado()) {
                <div class="[grid-column:1/-1]">
                    <p-button
                        [label]="mostrarFiltrosAvancados ? 'Ocultar filtros avancados' : 'Filtros avancados'"
                        [icon]="mostrarFiltrosAvancados ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
                        type="button"
                        [variant]="'text'"
                        (click)="toggleFiltrosAvancados()"
                    ></p-button>

                    @if (mostrarFiltrosAvancados) {
                        <p-accordion [value]="['identificacao']" [multiple]="true" class="block pt-2">
                            <p-accordion-panel value="identificacao">
                                <p-accordion-header>Identificação</p-accordion-header>
                                <p-accordion-content>
                                    <div class="grid grid-cols-[repeat(auto-fit,minmax(180px,1fr))] gap-4">
                                        <div class="field">
                                            <label for="cnpj" class="font-semibold block mb-2">CNPJ</label>
                                            <input pInputText id="cnpj" class="w-full" formControlName="cnpj" placeholder="Números e letras" />
                                        </div>
                                        <div class="field">
                                            <label for="nomeFantasia" class="font-semibold block mb-2">Nome Fantasia</label>
                                            <input pInputText id="nomeFantasia" class="w-full" formControlName="nomeFantasia" />
                                        </div>
                                        <div class="field">
                                            <label for="nomeUsual" class="font-semibold block mb-2">Nome Usual</label>
                                            <input pInputText id="nomeUsual" class="w-full" formControlName="nomeUsual" />
                                        </div>
                                    </div>
                                </p-accordion-content>
                            </p-accordion-panel>

                            <p-accordion-panel value="localizacao">
                                <p-accordion-header>Localização</p-accordion-header>
                                <p-accordion-content>
                                    <div class="grid grid-cols-[repeat(auto-fit,minmax(180px,1fr))] gap-4">
                                        <div class="field">
                                            <label for="municipioId" class="font-semibold block mb-2">Município</label>
                                            <p-select
                                                id="municipioId"
                                                [options]="municipios"
                                                formControlName="municipioId"
                                                optionLabel="label"
                                                optionValue="value"
                                                class="w-full"
                                                [showClear]="true"
                                                [filter]="true"
                                                placeholder="Todos"
                                                [emptyMessage]="uf === 'BR' ? 'Selecione uma UF' : 'Nenhum município'"
                                                appendTo="body"
                                            ></p-select>
                                        </div>
                                        <div class="field">
                                            <label for="endereco" class="font-semibold block mb-2">Endereço</label>
                                            <input pInputText id="endereco" class="w-full" formControlName="endereco" />
                                        </div>
                                        <div class="field">
                                            <label for="cep" class="font-semibold block mb-2">CEP</label>
                                            <input pInputText id="cep" class="w-full" formControlName="cep" />
                                        </div>
                                    </div>
                                </p-accordion-content>
                            </p-accordion-panel>

                            <p-accordion-panel value="situacaoTipo">
                                <p-accordion-header>Situação e Tipo</p-accordion-header>
                                <p-accordion-content>
                                    <div class="grid grid-cols-[repeat(auto-fit,minmax(180px,1fr))] gap-4">
                                        <div class="field">
                                            <label for="tipoInscricao" class="font-semibold block mb-2">Tipo de Inscrição</label>
                                            <p-select
                                                id="tipoInscricao"
                                                [options]="tiposInscricao"
                                                formControlName="tipoInscricao"
                                                optionLabel="label"
                                                optionValue="value"
                                                class="w-full"
                                                [showClear]="true"
                                                [filter]="true"
                                                placeholder="Todos"
                                                appendTo="body"
                                            ></p-select>
                                        </div>
                                        <div class="field">
                                            <label for="situacao" class="font-semibold block mb-2">Situação</label>
                                            <p-select
                                                id="situacao"
                                                [options]="situacoes"
                                                formControlName="situacao"
                                                optionLabel="label"
                                                optionValue="value"
                                                class="w-full"
                                                [showClear]="true"
                                                [filter]="true"
                                                placeholder="Todas"
                                                appendTo="body"
                                            ></p-select>
                                        </div>
                                        <div class="field">
                                            <label for="regCad" class="font-semibold block mb-2">Tipo (Reg/Cad)</label>
                                            <p-select id="regCad" [options]="regCads" formControlName="regCad" optionLabel="label" optionValue="value" class="w-full" [showClear]="true" placeholder="Todos" appendTo="body"></p-select>
                                        </div>
                                        <div class="field">
                                            <label for="categoria" class="font-semibold block mb-2">Categoria</label>
                                            <p-select id="categoria" [options]="categorias" formControlName="categoria" optionLabel="label" optionValue="value" class="w-full" [showClear]="true" placeholder="Todas" appendTo="body"></p-select>
                                        </div>
                                        <div class="field">
                                            <label for="instituido" class="font-semibold block mb-2">Instituído por</label>
                                            <p-select id="instituido" [options]="instituidos" formControlName="instituido" optionLabel="label" optionValue="value" class="w-full" [showClear]="true" placeholder="Todos" appendTo="body"></p-select>
                                        </div>
                                    </div>
                                </p-accordion-content>
                            </p-accordion-panel>

                            <p-accordion-panel value="classificacao">
                                <p-accordion-header>Classificação</p-accordion-header>
                                <p-accordion-content>
                                    <div class="grid grid-cols-[repeat(auto-fit,minmax(180px,1fr))] gap-4">
                                        <div class="field">
                                            <label for="filtroClassificacao" class="font-semibold block mb-2">Filtro de Classificação</label>
                                            <p-select
                                                id="filtroClassificacao"
                                                [options]="filtroClassificacoes"
                                                formControlName="filtroClassificacao"
                                                optionLabel="label"
                                                optionValue="value"
                                                class="w-full"
                                                [showClear]="true"
                                                placeholder="Todas"
                                                appendTo="body"
                                            ></p-select>
                                        </div>
                                        <div class="field">
                                            <label for="classificacao" class="font-semibold block mb-2">Classificação</label>
                                            <p-select
                                                id="classificacao"
                                                [options]="classificacoes"
                                                formControlName="classificacao"
                                                optionLabel="label"
                                                optionValue="value"
                                                class="w-full"
                                                [showClear]="true"
                                                [filter]="true"
                                                placeholder="Todas"
                                                (onChange)="onClassificacaoChange()"
                                                (onClear)="onClassificacaoChange()"
                                                appendTo="body"
                                            ></p-select>
                                        </div>
                                        <div class="field">
                                            <label for="subtipoClassificacao" class="font-semibold block mb-2">Porte/Tipo</label>
                                            <p-select
                                                id="subtipoClassificacao"
                                                [options]="subtipos"
                                                formControlName="subtipoClassificacao"
                                                optionLabel="label"
                                                optionValue="value"
                                                class="w-full"
                                                [showClear]="true"
                                                [filter]="true"
                                                [loading]="carregandoSubtipos"
                                                placeholder="Todos"
                                                appendTo="body"
                                            ></p-select>
                                        </div>
                                    </div>
                                </p-accordion-content>
                            </p-accordion-panel>

                            <p-accordion-panel value="outros">
                                <p-accordion-header>Outros</p-accordion-header>
                                <p-accordion-content>
                                    <div class="grid grid-cols-[repeat(auto-fit,minmax(180px,1fr))] gap-4">
                                        <div class="field">
                                            <label for="cnae" class="font-semibold block mb-2">CNAE</label>
                                            <p-autocomplete
                                                inputId="cnae"
                                                [(ngModel)]="cnaeSelecionado"
                                                [ngModelOptions]="{ standalone: true }"
                                                [suggestions]="cnaesSugeridos"
                                                (completeMethod)="buscarCnaes($event)"
                                                (onSelect)="onSelectCnae($event.value)"
                                                (onClear)="onSelectCnae(null)"
                                                optionLabel="label"
                                                [forceSelection]="true"
                                                styleClass="w-full"
                                                appendTo="body"
                                                placeholder="Código ou descrição"
                                            ></p-autocomplete>
                                        </div>
                                        <div class="field">
                                            <label for="gestaoTipo" class="font-semibold block mb-2">Tipo de Gestão</label>
                                            <p-select id="gestaoTipo" [options]="gestaoTipos" formControlName="gestaoTipo" optionLabel="label" optionValue="value" class="w-full" [showClear]="true" placeholder="Todos" appendTo="body"></p-select>
                                        </div>
                                        <div class="field">
                                            <label for="anotacoes" class="font-semibold block mb-2">Anotações (Contrato Social)</label>
                                            <input pInputText id="anotacoes" class="w-full" formControlName="anotacoes" />
                                        </div>
                                    </div>
                                </p-accordion-content>
                            </p-accordion-panel>
                        </p-accordion>
                    }
                </div>
            }

            <div class="field pt-5 flex justify-end gap-2">
                <p-button label="Limpar" icon="pi pi-eraser" type="button" [variant]="'text'" (click)="limparFormulario()"></p-button>
                <p-button label="Nova pessoa" icon="pi pi-plus" type="button" [variant]="'text'" (click)="abrirFormularioNovaPessoa()"></p-button>
                <p-button label="Pesquisar" icon="pi pi-search" type="button" (click)="pesquisar()"></p-button>
            </div>
        </div>

        <div class="h-full results-container pt-5">
            <p-table [value]="pessoas" selectionMode="single" [(selection)]="selectedPessoa" dataKey="code" [tableStyle]="{ 'min-width': '50rem' }" [scrollable]="true" [scrollHeight]="scrollHeight" stripedRows [loading]="carregando">
                <ng-template pTemplate="header">
                    <tr>
                        <th><strong>UF</strong></th>
                        <th><strong>Nome</strong></th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-item>
                    <tr [pSelectableRow]="item">
                        <td>{{ item.uf || '-' }}</td>
                        <td>{{ item.nome || '-' }}</td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="2" class="text-center">
                            <div class="p-5"><i>Nenhum registro encontrado.</i></div>
                        </td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="footer">
                    <tr class="custom-table-footer">
                        <td colspan="2">
                            <strong>Total de Registros: {{ totalRecords }}</strong>
                        </td>
                    </tr>
                </ng-template>
            </p-table>

            <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 15, 20]" [dropdownAppendTo]="'body'"></p-paginator>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-text" type="button" (click)="hideDialog()" />
        <p-button label="Selecionar" icon="pi pi-check" type="button" (click)="selecionar()" [disabled]="!selectedPessoa" />
    </ng-template>
</p-dialog>

<p-dialog
    appDialogoPadrao="pi pi-plus"
    descricao="Registre alguém que ainda não está no cadastro."
    [(visible)]="showDialogNovaPessoa"
    (onHide)="cancelarCadastroNovaPessoa()"
    header="Cadastro de Nova Pessoa"
    [style]="{ width: 'min(95vw, 72rem)' }"
    [breakpoints]="{ '1280px': '90vw', '768px': '95vw' }"
>
    <ng-template pTemplate="content">
        <div class="p-fluid grid grid-cols-1 md:grid-cols-12 gap-4 mt-2" [formGroup]="formNovaPessoa">
            <div class="field md:col-span-4">
                <label for="tipoNovaPessoa" class="font-semibold block mb-2">Tipo</label>
                <p-select id="tipoNovaPessoa" [options]="tiposCadastro" formControlName="tipo" optionLabel="name" optionValue="code" class="w-full"></p-select>
            </div>

            <div class="field md:col-span-3">
                <label for="ufNovaPessoa" class="font-semibold block mb-2">UF</label>
                <app-estado-select [uf]="formNovaPessoa.controls.uf.value" [ufsPermitidas]="ufsPermitidas" (ufChange)="changeUfNovaPessoa($event)"></app-estado-select>
            </div>

            <div class="field md:col-span-5">
                <label for="cpfOuCnpjNovaPessoa" class="font-semibold block mb-2">CPF/CNPJ</label>
                <input pInputText id="cpfOuCnpjNovaPessoa" class="w-full" formControlName="cpfOuCnpj" placeholder="Somente números" />
            </div>

            <div class="field md:col-span-6">
                <label for="nomeNovaPessoa" class="font-semibold block mb-2">Nome / Razão Social</label>
                <input pInputText id="nomeNovaPessoa" class="w-full" formControlName="nome" placeholder="Nome / Razão Social" />
            </div>

            <div class="field md:col-span-6">
                <label for="nomeSocialNovaPessoa" class="font-semibold block mb-2">Nome social</label>
                <input pInputText id="nomeSocialNovaPessoa" class="w-full" formControlName="nomeSocial" />
            </div>

            <div class="field md:col-span-6">
                <label for="emailNovaPessoa" class="font-semibold block mb-2">Email</label>
                <input pInputText id="emailNovaPessoa" class="w-full" formControlName="email" />
            </div>

            <div class="field md:col-span-6">
                <label for="homepageNovaPessoa" class="font-semibold block mb-2">Homepage</label>
                <input pInputText id="homepageNovaPessoa" class="w-full" formControlName="homepage" />
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <p-button label="Cancelar" icon="pi pi-times" type="button" [variant]="'text'" (click)="cancelarCadastroNovaPessoa()"></p-button>
        <p-button label="Salvar nova pessoa" icon="pi pi-check" type="button" (click)="cadastrarNovaPessoa()" [loading]="cadastrandoPessoa"></p-button>
    </ng-template>
</p-dialog>
